import Vue from 'vue';

import { apiPath } from '../constants';

const AdInsight = Vue.resource(
  `${apiPath}/adbazaar/stats/campaign{/itemId}{/stats}{/action}{/subAction}/`,
  {},
  {
    getStatData: {
      method: 'GET',
      params: { stats: 'builder' },
    },
    getStatsTypes: {
      method: 'GET',
      params: { stats: 'builder', action: 'stat-types' },
    },
    getCampaignOverallStats: {
      method: 'GET',
      params: { stats: 'overall' },
    },
    getCampaignBidsStats: {
      method: 'GET',
      params: { stats: 'bids' },
    },
    searchQuery: {
      method: 'GET',
      params: { stats: 'builder', action: 'bids' },
    },
    getChartStatTypes: {
      method: 'GET',
      params: {
        stats: 'builder',
        action: 'stat-types',
        subAction: 'tree',
      },
    },
    saveStatsBuilderCSV: {
      method: 'GET',
      params: { stats: 'builder', action: 'export' },
    },
    saveOverallCSV: {
      method: 'GET',
      params: { stats: 'overall', action: 'export' },
    },
  },
);

export default AdInsight;
